import {FC, PropsWithChildren, useMemo, useState} from "react";
import {ThemeProvider as MuiThemeProvider} from "@mui/material/styles";
import {ThemeName, themes} from "../themes";
import {ThemeContext} from "../context/Theme.ts";

type ProviderProps = PropsWithChildren

const Provider: FC<ProviderProps> = ({children}) => {
    const [currentThemeName, setThemeByName] = useState<ThemeName>('default')
    const theme = useMemo(() => themes.get(currentThemeName)!, [currentThemeName])
    const themeContextValue = useMemo(() => ({
        themeName: currentThemeName,
        setThemeByName,
    }), [currentThemeName])
    return (
        <ThemeContext.Provider value={themeContextValue}>
            <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
        </ThemeContext.Provider>
    )
}

export default Provider
